import React from 'react';
import Vacancy from './Vacancy'
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import usePortalService from '../../services/PortalService';
import { AdminNavbar } from '../../Components/Navbars';

let vacancyId: string;
export const VacancyAdmin = () => {
    const { getVacancyById } = usePortalService();

    const params = useParams();
    vacancyId = params.id as string;
    const [vacancy, setVacancy] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        getVacancyById(vacancyId)  
        .then(result => {
            if (result.success){
                setVacancy(result.vacancy)
            } else {
                setError(result.errors)
            }
        });
    }, []);

    return (
        <>
            <AdminNavbar/>
            {
                vacancy ? 
                <Vacancy vacancy={vacancy} userRole={"profile"}>
                </Vacancy> :
                <p style={{paddingTop:'100px', paddingLeft: '150px'}}> {error} </p>
            }
        </>
    );
}